import moment from 'moment';
import React, { Component } from 'react';
import * as Http from '../../../http';
import _ from 'lodash';
import { getRarocDashBoard } from '../../../http';
import OverviewByBranch from './OverviewByBranch/OverviewByBranch';
import OverviewWholeBank from './OverviewWholeBank/OverviewWholeBank';
import { ONE_BILLION } from '../utils';
import { COMPONENT } from '../../../utils/business';

const transformData = (dataSource) => {
  const data = {};
  //Fake DEMO data
  _.set(dataSource, 'bankwide[0].economic_profit', 713 * ONE_BILLION)
  _.set(dataSource, 'pr_bankwide[0].n_economic_capital', 29.92 * ONE_BILLION)
  dataSource.in_icaap && dataSource.in_icaap.forEach(o => {
    if (o.no === '6.1') {
      o.t0_bau = 9.83;
    }
  })
  //End
  console.log('🚀 ~ Dashboard ~ dataSource:', dataSource);
  dataSource &&
    Object.keys(dataSource).forEach((key) => {
      const value = dataSource[key];
      if (key === 'bankwide') {
        data[key] = (value && value[0]) || [];
      } else {
        data[key] = value;
      }
    });
  return data;
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportDate: null,
      snapshotDates: [],
    };
  }
  getData = async () => {
    const reportDate = await this.getListFile();
    const data = await getRarocDashBoard(reportDate);
    if (data) {
      const newData = transformData(data);
      this.setState({ data: newData });
    }
  };
  componentDidMount() {
    this.getData();
  }

  onChangeDate = (date) => {
    this.setState(
      {
        reportDate: date,
      },
      async () => {
        const data = await getRarocDashBoard(this.state.reportDate);
        if (data) {
          const newData = transformData(data);
          this.setState({ data: newData });
        }
      }
    );
  };

  getListFile = async () => {
    return new Promise((resolve) => {
      Http.getListBatch(COMPONENT.RAROC, null).then((data) => {
        if (data && data.Success) {
          let listData = [];
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (!element) continue;
            if (element.file_name.includes('ICAAP_') || element.file_name.includes('CAR_'))
              continue;
            const formatedDate = moment(element.report_date).format('DD/MM/YYYY');
            if (!listData.includes(formatedDate)) listData.push(formatedDate);
          }
          listData = listData.sort((a, b) => {
            return new Date(a.report_date).getTime() - new Date(b.report_date).getTime();
          });
          this.setState({
            reportDate: listData[0],
            snapshotDates: listData,
          });
          return resolve(listData[0]);
        }
      });
    });
  };

  render() {
    return (
      <div>
        {/* <div style={{display: 'flex', gap: '8px', width: '40%'}}>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'row',
              flex: 1,
              alignContent: 'stretch',
              justifyContent: 'flex-start',
            }}>
            <p style={{fontWeight: 700, marginRight: '10px'}}>Report Date</p>
            <ButtonGroup vertical style={{marginBottom: '10px'}}>
              <DropdownButton title={this.state.reportDate} bsSize='small' block='true'>
                {this.state.snapshotDates.map((date) => [
                  <MenuItem onSelect={(eventKey, _) => this.onChangeDate(eventKey)} eventKey={date}>
                    {date}
                  </MenuItem>,
                  <MenuItem divider />,
                ])}
              </DropdownButton>
            </ButtonGroup>
          </div>
        </div> */}
        <OverviewWholeBank
          data={this.state.data}
          reportDate={this.state.reportDate}
          snapshotDates={this.state.snapshotDates}
          onChangeDate={this.onChangeDate}
        />
        <OverviewByBranch data={this.state.data} />
      </div>
    );
  }
}
export default Dashboard;



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/index.js